module.exports = __webpack_public_path__ + "static/media/vitaldetails5.b48d3a07.png";